/* eslint-disable no-undef */
import React from 'react';
import { Styles } from './styles';
import { WhatsApp, Mail } from '@mui/icons-material';
import { IPropertyCorretor } from '@stores/Property/types';

interface AgentInfoProps {
  agent: IPropertyCorretor;
}

const AgentInfo: React.FC<AgentInfoProps> = ({ agent }) => {
  if (!agent) {
    return null;
  }

  return (
    <Styles.AgentContainer>
      <Styles.AgentBox>
        <Styles.AgentHeading>Corretor</Styles.AgentHeading>
        <Styles.AgentPhoto src={agent.avatar || ''} alt="Foto do Corretor" />
      </Styles.AgentBox>
      <Styles.AgentBoxBot>
        <Styles.AgentName>
          {agent.name} - {agent.creci}
        </Styles.AgentName>
        <Styles.AgentInfos>
          <Styles.AgentPhone>
            <WhatsApp
              sx={{ fontSize: 23, marginRight: '8px', color: '#236e45' }}
            />
            {agent.cellphone}
          </Styles.AgentPhone>
          <Styles.AgentEmail>
            <Mail
              sx={{
                fontSize: 23,
                marginRight: '8px',
                marginBottom: '-5px',
                color: '#236e45'
              }}
            />
            {agent.email}
          </Styles.AgentEmail>
        </Styles.AgentInfos>
      </Styles.AgentBoxBot>
    </Styles.AgentContainer>
  );
};

export default AgentInfo;
